module.exports = __webpack_public_path__ + "img/up-down-left-right.f0d7200a.svg";